module.exports = __webpack_public_path__ + "static/media/article2.e86cd374.jpg";